export enum OrganisationGroupValidationFailureCode {
  ShortName,
  Description,
  AtLeastOneField,
  TableauAccessGroup,
  FallbackTableauAccessGroup,
  NoOrganisationGroups,
}
